import './style.scss';
import { state } from './scripts/partials/state';
import { setActiveItem, updateActiveItem } from './scripts/partials/activeItem';
import {
  setupBreakpoints,
  checkPenultimateItemOutOfView,
} from './scripts/partials/breakpoints';

/**
 * Main entry point: initializes archive production functionality
 */
document.addEventListener('DOMContentLoaded', () => {
  // Setup state from DOM
  state.section = document.querySelector('.archive_production');
  state.productionList = document.querySelector(
    '.archive_production-productions',
  );
  state.mediaContainer = document.querySelector('.archive_production-media');
  state.productionItems = Array.from(
    state.productionList.querySelectorAll('.archive_production-production .archive_production-link'),
  );
  state.preloadImages = Array.from(
    state.mediaContainer.querySelectorAll('.preload-image'),
  );
  state.fullResPictures = Array.from(
    state.mediaContainer.querySelectorAll('.full-res-picture'),
  );
  state.sprites = Array.from(
    state.section.querySelectorAll('.archive_production-placeholder-sprite'),
  );
  state.loadingSpinner = state.mediaContainer.querySelector('.lds-dual-ring');
  state.activeItemIndex =
    parseInt(state.section.getAttribute('data-active-index'), 10) || 0;

  // Setup autoplay preference based on reduced motion and cookies
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;
  if (prefersReducedMotion) {
//    const savedPref = getCookie('autoplayEnabled');  disabling cookie
//    state.autoplayEnabled = savedPref !== 'false'; // default true if missing
    state.autoplayEnabled = true;
//  } else {
//    deleteCookie('autoplayEnabled');
  }

  // Setup breakpoints
  setupBreakpoints();

  // Event listeners
  if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
    state.productionItems.forEach(item =>
      item.addEventListener('mouseenter', () => setActiveItem(item)),
    );
  }

  let scrollTimeout;
  state.productionList.addEventListener(
    'scroll',
    () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        updateActiveItem();
      }, 25);
      checkPenultimateItemOutOfView(0);
    },
    { passive: true },
  );

  window.addEventListener('resize', updateActiveItem);

  // Initial activation
  const initial = state.productionItems[state.activeItemIndex];
  setActiveItem(initial, true);
  checkPenultimateItemOutOfView(0);

  const search = document.getElementById("search");
  search.addEventListener("input", searchChanged);
  search.addEventListener("focus", searchChanged);
  search.addEventListener("blur", searchChanged);
  searchChanged();

//  document.querySelectorAll('a.disabled-link').forEach(link => {
//    link.addEventListener('click', function (e) {
//      e.preventDefault(); // Prevents navigation
//      e.stopPropagation(); // Stops any JS that might use bubbling
//    });
//  });
});

function searchChanged() {
  const search = document.getElementById("search");
  const searchBlock = document.querySelector(".archive_production-search");
  const noResults = document.getElementById("no_results");
  const searchFor = search.value.toLowerCase().trim();
  const searching = searchFor!="";
  const productionUL = document.querySelector(".archive_production-productions");
  const productions = document.querySelectorAll(".archive_production-production");
  const padding = document.querySelector(".archive_production-list_padding");
  const footer = document.querySelector(".archive_production-list_footer");

  if (searching || document.activeElement===search) {
    search.parentNode.parentNode.classList.add("searching");
  } else {
    search.parentNode.parentNode.classList.remove("searching");
  }

  const lastSearch = search.dataset.lastSearch || ""
  if (lastSearch===search.value) {
    return;
  }
  search.dataset.lastSearch=search.value;

  let sortedList = Array.from(productions)
  if (searching) {
    sortedList = sortedList.filter(function(a){
      return a.dataset.txt.indexOf(searchFor)>=0;
    });
    sortedList.sort(function(a,b) {
      const idxa = a.dataset.txt.indexOf(searchFor);
      const idxb = b.dataset.txt.indexOf(searchFor);
      if ((idxa===0) && (idxb!==0)) {
        return -1;
      }
      if ((idxb===0) && (idxa!==0)) {
        return 1;
      }
      return a.dataset.txt.localeCompare(b.dataset.txt);
    });
  } else {
    sortedList.sort(function(a,b) {
      return parseInt(a.dataset.order,10) - parseInt(b.dataset.order,10);
    });
  }

  console.log(sortedList)

  var nextItem = searchBlock.nextElementSibling;
  for (let i=0; i<sortedList.length; i++) {
    if (nextItem!==sortedList[i]) {
      productionUL.insertBefore(sortedList[i], nextItem);
    } else {
      nextItem = nextItem.nextElementSibling;
    }
    sortedList[i].style.display="";
  }
  for (; nextItem!=padding; nextItem = nextItem.nextElementSibling) {
    nextItem.style.display="none";
  }

  const hasResults = sortedList.length>0;
  noResults.style.display = hasResults ? "none" : "";
  if (hasResults) {
    setActiveItem(sortedList[0].firstElementChild, true);
  }
}
